import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
export function BeyondSystemPrompt() {
  return <section className="pt-0 pb-14 px-6 md:px-12 lg:px-24 bg-white" data-id="element-225">
      <div className="max-w-7xl mx-auto" data-id="element-226">
        {/* Top border line */}
        <div className="h-px bg-gray-200 w-full mb-12" data-id="element-227"></div>

        {/* Headline - OUTSIDE grid to span full width, smaller font, 2 lines */}
        <h2 className="text-3xl lg:text-4xl font-bold mb-12 leading-tight tracking-tight font-['Syne']" data-id="element-228">
          Anthropic's internal system prompt leaked.
          <br data-id="element-229" />
          That gives the model control, not you.
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-230">
          {/* Left Column */}
          <div data-id="element-231">
            {/* Paragraph - MUST align with "Stanford University..." on right */}
            <p className="text-lg text-gray-600 leading-relaxed mb-12 font-['Lora']" data-id="element-232">
              Claude's behavior is governed by 24,000 tokens of instructions
              covering safety rules, refusal logic, and decision hierarchies. AI
              behavior has always been governed at the instruction layer—the
              difference is that model providers control it, and enterprises
              don't.{' '}
              <strong className="text-black font-semibold" data-id="element-233">
                Synthia changes that.
              </strong>
            </p>

            {/* Green box */}
            <div className="p-8 bg-green-50 border border-green-100 rounded-lg" data-id="element-234">
              <div className="flex items-start gap-4" data-id="element-235">
                <ShieldCheck className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-236" />
                <div data-id="element-237">
                  <h3 className="font-bold text-green-900 mb-4 text-lg" data-id="element-238">
                    Control the Instruction Layer
                  </h3>
                  <div className="space-y-3" data-id="element-239">
                    <div className="flex items-start gap-3" data-id="element-240">
                      <Check className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" data-id="element-241" />
                      <p className="text-green-800 text-base" data-id="element-242">
                        Modify reasoning rules to match your policies
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-243">
                      <Check className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" data-id="element-244" />
                      <p className="text-green-800 text-base" data-id="element-245">
                        Audit every instruction applied to your AI
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-246">
                      <Check className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" data-id="element-247" />
                      <p className="text-green-800 text-base" data-id="element-248">
                        Align with your compliance requirements automatically
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-249">
                      <Check className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" data-id="element-250" />
                      <p className="text-green-800 text-base" data-id="element-251">
                        Encode your expert judgment as machine-readable logic
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-252">
                      <Check className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" data-id="element-253" />
                      <p className="text-green-800 text-base" data-id="element-254">
                        Own your reasoning layer—independent of any model
                        
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - positioned to align text with left paragraph */}
          <div className="flex gap-6 items-start" data-id="element-255">
            {/* Red vertical line */}
            <div className="relative flex-shrink-0 pt-1" data-id="element-256">
              <div className="w-px bg-red-600 h-[120px]" data-id="element-257"></div>
            </div>

            {/* Content */}
            <div className="flex flex-col gap-8" data-id="element-258">
              {/* Text block */}
              <div data-id="element-259">
                <p className="text-gray-700 leading-relaxed font-['Syne']" data-id="element-260">
                  Stanford University proved it.{' '}
                  <span className="underline" data-id="element-261">RAG precision:</span> 87% drop at
                  50,000+ documents. Adding more context increases
                  hallucinations, without governance.{' '}
                  <span className="underline" data-id="element-262">ACE performance:</span> 10.6%
                  better than fine-tuning, 86.9% lower cost. The conclusion is
                  definitive—The instruction layer isn't optional.{' '}
                  <strong className="font-bold" data-id="element-263">It's essential.</strong>
                </p>
              </div>

              {/* Stanford graphic */}
              <div className="relative" data-id="element-264">
                <img src="https://cdn.magicpatterns.com/uploads/ffGC6DCXJkxHk7yTR5GHJL/safiord_shot.png" alt="Stanford AI Lab - Claude Code's System Prompts Just Leaked" className="w-full h-auto" data-id="element-265" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}